module.exports = __webpack_public_path__ + "img/login_bg.fa144e9e.png";